import { useSelector } from "react-redux";
import { useRef, useState } from "react";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import { successMessage } from "../../utils/toastify-message/ToastifyMessage";
import UserModal from "../../components/common/modals/user-modal/UserModal";
import { PiXFill } from "react-icons/pi";

export default function UserReportsFilter({ filterDataHandler }) {
  const { utils } = useSelector(utilsState);
  const userModalRef = useRef();

  const [user, setUser] = useState(null);

  const handleUser = (data) => {
    setUser(data.name);
    successMessage(`کاربر ${data?.name} انتخاب شد`);
    filterDataHandler({ page: 1, user: data?._id });
  };

  const deleteUser = () => {
    setUser("");
    filterDataHandler({ page: 1, user: "" });
  };

  return (
    <div className="w-full flex flex-col flex-wrap my-8 gap-6 px-6">
      <UserModal ref={userModalRef} handleUser={handleUser} />
      <div className="admin-filter-grid">
        <div className="relative">
          <span
            onClick={() => userModalRef?.current?.showModal()}
            className="absolute w-full h-full"
          ></span>
          {user ? (
            <PiXFill
              className=" cursor-pointer absolute left-2 bottom-4 text-red-500"
              onClick={deleteUser}
            />
          ) : null}
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            انتخاب کاربر
          </label>
          <input
            value={user}
            onChange={(e) => setUser(e.target.value)}
            disabled
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          />
        </div>
      </div>
    </div>
  );
}
